import store from '../store/redux/index'; // Your Redux store
// eslint-disable-next-line no-unused-vars

window.getTexts = () => {
    const state = store.getState();
    return state.translate.texts
};

window.getUserName = () => {
    const state = store.getState();
    return state.auth?.user?.given_name;
};

window.getUserExternalId = () => {
    const state = store.getState();
    return state.auth?.user?.exidentifier;
};

// window.getUserDetails = () => {
//     const state = store.getState();
//     return state.user
// }

window.uploadImage = async (file, questionKey) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('questionKey', questionKey);
    try {
        const response = await fetch(`${window.config.baseApiUrl}/api/image/upload`, {
            method: 'POST',
            body: formData,
            credentials: "include"
        });

        if (!response.ok) {
            return null
        }
        else {
            const data = await response.json();
            return data.url;
        }
    } catch (error) {
        console.error('Image upload failed:', error);
        return null
    }
}
